import type { ReactNode } from 'react'
import React from 'react'

interface GlobalActionsProps {
  children: ReactNode
}

function GlobalActions({ children }: GlobalActionsProps): JSX.Element {
  return <div className="flex items-center space-x-2">{children}</div>
}

export default GlobalActions
